import { render, staticRenderFns } from "./SavedAddressSelect.vue?vue&type=template&id=99a5b5f8"
import script from "./SavedAddressSelect.vue?vue&type=script&lang=js"
export * from "./SavedAddressSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports